import { v4 } from 'uuid';

import { bootstrapConfig } from '~src/context/config';
import { useGlobalState } from '~src/global-state';
import { useIpc } from '~src/utils/ipc-utils';

const defaultUserId = v4();

/*
 * Generated userId is sent to bootstrap via ipc
 * On the next visit it will be passed via iframe query params
 */
export function useUserId(): [string, () => void] {
  const globalState = useGlobalState();
  const ipc = useIpc();

  const userId = globalState.address_book?.user_id ?? bootstrapConfig.userId ?? defaultUserId;

  const saveUserId = () => {
    ipc.send({
      name: 'user_id',
      data: userId,
    });
  };

  return [userId, saveUserId];
}
